import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { PwaService } from '@app/core/services/pwa.service';
import { TvNavigationService } from '@app/core/services/tv-navigation.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent implements OnInit {
  isVisible = false;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
    private readonly pwaService: PwaService,
    private readonly tvService: TvNavigationService
  ) {}

  ngOnInit(): void {
    // Initial check
    this.checkVisibility();

    // Re-check on every navigation
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkVisibility();
      });
  }

  checkVisibility(): void {
    const isHome = this.router.url === '/' || this.router.url === '/home';
    if (isHome) {
      this.isVisible = false;
      return;
    }

    // Show if:
    // 1. Is PWA (Standalone)
    // 2. OR Is iOS (Safari often lacks back button if fullscreen)
    // 3. OR Is TV Mode (Remote users need explicit back)
    const isPwa = this.pwaService.isInStandaloneMode();
    const isIos = this.pwaService.isIos(); // We added this method previously
    const isTv = this.tvService.isTvMode; // Check if TV mode is active

    // User requested: "Mobile View in PWA in iOS and some android phone... Make sure in PWA and mobile + TV view only"
    // So we show it for PWA, iOS, or TV.
    // We intentionally do NOT show it for standard desktop browser (unless it's in PWA standalone mode).
    this.isVisible = isPwa || isIos || isTv;
  }

  goBack(): void {
    this.location.back();
  }
}
